export default __webpack_public_path__ + "static/media/Velocipastor.8e6ca317.png";